import SiteMapViewer from "@/components/site_map/SiteMapViewer.svelte"
import { Controller } from "@hotwired/stimulus"
import { getCustomerSiteMap, getCustomerSiteMapUnitStatuses } from "api/site_maps"

export default class extends Controller {
  static values = {
    siteMapId: String,
  }

  connect() {
    this.siteMapViewer = new SiteMapViewer({
      props: {
        getSiteMap: getCustomerSiteMap,
        getUnitStatuses: getCustomerSiteMapUnitStatuses,
        isRestricted: true,
        siteMapId: this.siteMapIdValue,
      },
      target: this.element,
    })
  }

  disconnect() {
    this.siteMapViewer.$destroy()
  }
}
